import React from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
const Mission = () => {
  return (
    <>
      <Header />
      <div>
        <div class="bg_color_1 my-5">
          <div class="container margin_120_95">
            <div class="main_title">
              <h1> Mission Statement</h1>
            </div>
            <div class="row justify-content-center">
              <div class="col-lg-9 fs-5">
                <p>
                  The field of hypnosis has experienced over 10,000
                  peer-reviewed research studies across the globe within the
                  past 50 years. This surpasses the amount of research regarding
                  both meditation and yoga which have both reached mainstream
                  acceptance. However, the stigma surrounding hypnosis based on
                  its usage for entertainment purposes has affected its adoption
                  and utilization within clinical practice. This effect is
                  detrimental to clinicians, hypnotherapists, and most
                  importantly the patient population. GAFHC aims to overcome
                  this by creating a global alliance of optimally-trained,
                  certified practitioners of this field while developing
                  premium-quality content highlighting the continuous rigorous
                  ongoing research regarding the effects of hypnosis on pain,
                  emotional distress, and neurological benefits.
                </p>
              </div>
            </div>
            {/* <!--/row--> */}
          </div>
          {/* <!--/container--> */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Mission;
